import { configureStore } from '@reduxjs/toolkit';
import fittingReducer from '../features/fitting/fittingSlice';

export const store = configureStore({
  reducer: {
    fitting: fittingReducer,
  },
});
